export enum FileUploadStatus {
    Fail = 'Fail',
    Succeeded = 'Succeeded',
    InProgress = "InProgress"
  }
  